/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';
import { ModalitaConvenzione } from './modalita-convenzione';
import { DocumentoConvenzioneRichiesto } from './documento-convenzione-richiesto';


export interface AzioneOperatoreEsercenteDTO { 
    nuovo_stato?: RichiestaPraticaEsercenteStatus;
    modalita_convenzione?: ModalitaConvenzione;
    documento_richiesto?: DocumentoConvenzioneRichiesto;
    nota_obbligatoria?: boolean;
}



